import api from '@/api'
import store from '@/stores/products'

export default {
  all() {
    return api.get('/products')
  },

  find(productId) {
    return api.get(`/products/${productId}`)
  },

  byClientid(clientId) {
    return api.get(`/clients/${clientId}/products`)
  },

  hydrate(clientId = false) {
    if(clientId) {
      return this.byClientid(clientId).then(res => {
        store.setProducts(res.data.products)
      })
    }
  },  
}
